/** 只维护当前活动的分享图片元信息，退出时恢复原页面，不发送分享请求。 */
export function createActivityShareMetadata(document) {
  let records = [];
  function clear() {
    for (const record of records) {
      if (record.node.getAttribute('content') !== record.current) continue;
      if (record.created) record.node.remove();
      else if (record.before === null) record.node.removeAttribute('content');
      else record.node.setAttribute('content', record.before);
    }
    records = [];
  }
  function update(imageUrl) {
    if (!document?.head) return;
    let url;
    try {
      if (typeof imageUrl !== 'string' || !imageUrl.trim()) return clear();
      url = new URL(imageUrl.trim(), document.baseURI);
      if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return clear();
    } catch { return clear(); }
    if (!records.length) {
      for (const [attribute, value] of [['property', 'og:image'], ['name', 'twitter:image']]) {
        let node = document.head.querySelector(`meta[${attribute}="${value}"]`);
        const created = !node;
        if (!node) { node = document.createElement('meta'); node.setAttribute(attribute, value); document.head.appendChild(node); }
        records.push({ node, created, before: node.getAttribute('content'), current: '' });
      }
    }
    for (const record of records) { record.current = url.href; record.node.setAttribute('content', record.current); }
  }
  return { update, clear };
}
